import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=2864b31a&scoped=true&lang=pug"
import script from "./InstitutionList.vue?vue&type=script&lang=js"
export * from "./InstitutionList.vue?vue&type=script&lang=js"
import style0 from "./InstitutionList.vue?vue&type=style&index=0&id=2864b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864b31a",
  null
  
)

export default component.exports